import { types, DataChartActionsType, IDataChartData } from '../types/datachart'

export const initialState: IDataChartData = {
  isLoading: false,
  dataStreamURI: '',
  title: '',
}

export const datachart = (
  state = initialState,
  action: DataChartActionsType
): IDataChartData => {
  switch (action.type) {
    case types.CREATE_DATACHART__STARTED:
      return {
        ...state,
        isLoading: true,
        title: action.title,
        dataStreamURI: action.dataStreamURI,
      }
    case types.CREATE_DATACHART_SHOW_PROGRESS:
      return {
        ...state,
        isLoading: true,
      }
    case types.CREATE_DATACHART__SUCCESS:
    case types.CREATE_DATACHART_HIDE_PROGRESS:
      return initialState
    case types.CREATE_DATACHART__FAILURE:
      return { ...initialState, isLoading: false }
    default:
      return state
  }
}
